import React from 'react';
import { Link } from 'react-router-dom';
import { Waves, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-blue-600 rounded-xl flex items-center justify-center">
                <Waves className="w-6 h-6 text-white" />
              </div>
              <span className="text-2xl font-bold">Reflow</span>
            </div>
            <p className="text-slate-400 leading-relaxed">
              Il sistema operativo per proprietari che vogliono affittare in modo sicuro.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Navigazione</h3>
            <div className="space-y-3">
              <Link to="/" className="block text-slate-400 hover:text-emerald-400 transition-colors">
                Home
              </Link>
              <Link to="/vision" className="block text-slate-400 hover:text-emerald-400 transition-colors">
                Vision
              </Link>
              <a 
                href="/#property-form" 
                className="block text-slate-400 hover:text-emerald-400 transition-colors"
              >
                Diventa Fondatore
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contatti</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-400">Pescara, Italia</span>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:info@reflow.rent" className="text-slate-400 hover:text-emerald-400 transition-colors">
                  info@reflow.rent
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} Reflow. Tutti i diritti riservati.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-slate-500 hover:text-emerald-400 text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-slate-500 hover:text-emerald-400 text-sm transition-colors">
                Termini di Servizio
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
